import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-64118588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issue_type" }
const _hoisted_2 = { class: "issue_type_content" }
const _hoisted_3 = {
  key: 0,
  class: "back_button"
}
const _hoisted_4 = { class: "issue_type__content" }
const _hoisted_5 = {
  key: 0,
  class: "issue_type__heading"
}
const _hoisted_6 = { class: "issue_type__heading_prefix" }
const _hoisted_7 = { class: "notification" }
const _hoisted_8 = { class: "issue_type__heading_text" }
const _hoisted_9 = { class: "issue_type__heading_title" }
const _hoisted_10 = {
  key: 1,
  class: "issue_cards"
}
const _hoisted_11 = { class: "issue_type__cards" }
const _hoisted_12 = { class: "issue_type__card_item__icon" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "issue_type__card_item__text" }
const _hoisted_15 = {
  key: 3,
  class: "issue_specify"
}
const _hoisted_16 = { class: "issue_specify__content" }
const _hoisted_17 = { class: "issue_specify__text" }
const _hoisted_18 = { class: "custom_editor" }
const _hoisted_19 = { class: "selected-info" }
const _hoisted_20 = {
  key: 4,
  class: "attachment__wrapper"
}
const _hoisted_21 = { class: "attachment__wrapper__upload" }
const _hoisted_22 = { class: "left_upload_img" }
const _hoisted_23 = { class: "upload__area" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" Upload images and files. "),
  /*#__PURE__*/_createElementVNode("span", null, "(Optional)")
], -1))
const _hoisted_25 = { class: "upload__section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ", -1))
const _hoisted_27 = { class: "uploade-wrapper secondary_upload_file" }
const _hoisted_28 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_29 = { class: "selected-info" }
const _hoisted_30 = { class: "image__upload__wrapper" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded Files", -1))
const _hoisted_33 = { class: "uploaded_details_wrapper" }
const _hoisted_34 = { class: "prop_img_details" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_36 = { class: "upload__list" }
const _hoisted_37 = {
  key: 1,
  class: "blank_project"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your added project attachments will show up here", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "issue_type__overview"
}
const _hoisted_41 = { class: "issue_type__overview_card_content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Issue Overview")
], -1))
const _hoisted_43 = { class: "issue_type__overview_card_text" }
const _hoisted_44 = { class: "issue_type__overview_card_text_item" }
const _hoisted_45 = { class: "issue_type__overview_list" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address", -1))
const _hoisted_47 = {
  key: 0,
  class: "property_address"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "issue_type__overview_card_text_item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Issue Details", -1))
const _hoisted_51 = { class: "issue_type__overview_list" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Issue Type", -1))
const _hoisted_53 = { class: "modal__footer" }
const _hoisted_54 = {
  key: 0,
  class: "issue_type__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_PropertyListComponentRaiseIssue = _resolveComponent("PropertyListComponentRaiseIssue")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_IssueReviewComponent = _resolveComponent("IssueReviewComponent")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_EmergencyOutHoursEventList = _resolveComponent("EmergencyOutHoursEventList")!
  const _component_EmergencyOutHoursDetails = _resolveComponent("EmergencyOutHoursDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!$setup.isShowIssueReview && ![1, 2].includes($setup.currentSelectedTab?.id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                variant: "text",
                "aria-label": "Refresh",
                class: "button button-transparent",
                "prepend-icon": "mdi-chevron-left",
                onClick: $setup.onClickBackButton
              }, {
                default: _withCtx(() => [
                  _createTextVNode("back")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["issue_type_content_wrapper", {
          'full-view': [1, 2].includes($setup.currentSelectedTab?.id),
          'main-review': $setup.isShowIssueReview,
        }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (![1, 2].includes($setup.currentSelectedTab.id) && !$setup.isShowIssueReview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString($setup.currentSelectedTab.id - 1), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.currentSelectedTab.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString($setup.currentSelectedTab.title), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.issuesTypeList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_card, {
                        class: _normalizeClass(["issue_type__card_item", { selected: item.selected }]),
                        key: index,
                        onClick: ($event: any) => ($setup.toggleSelectionType(index))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            (item.iconName)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  class: "list_content_btn"
                                }, {
                                  default: _withCtx(() => [
                                    (item.iconName)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: require('@/assets/icons/' + item.iconName + '.svg'),
                                          alt: "icon"
                                        }, null, 8, _hoisted_13))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h5", null, _toDisplayString(item.name), 1),
                            _createElementVNode("p", null, _toDisplayString(item.subTitle), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id === 2)
              ? (_openBlock(), _createBlock(_component_PropertyListComponentRaiseIssue, {
                  key: 2,
                  className: "raise_issue_property_list",
                  workflowType: $setup.PropertyWorkflowTypeEnum.RAISE_AN_ISSUE,
                  onOnClickBackButton: $setup.onClickBackButton,
                  onOnGoAddHistoricalPage: $setup.afterSelectingProperty
                }, null, 8, ["workflowType", "onOnClickBackButton", "onOnGoAddHistoricalPage"]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_text_field, {
                        placeholder: "Issue title",
                        modelValue: $setup.issueDetails.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.issueDetails.name) = $event)),
                        variant: "underlined",
                        density: "compact"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_quill_editor, {
                          value: $setup.issueDetails.description,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.issueDetails.description) = $event)),
                          options: $setup.state.editorOption,
                          disabled: $setup.state.disabled,
                          onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.onEditorBlur($event))),
                          onFocus: _cache[3] || (_cache[3] = ($event: any) => ($setup.onEditorFocus($event))),
                          onReady: _cache[4] || (_cache[4] = ($event: any) => ($setup.onEditorReady($event))),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.onEditorChange($event))),
                          class: "editor_ql"
                        }, null, 8, ["value", "options", "disabled"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_v_btn, {
                      "aria-label": "Refresh",
                      class: "button button-purple min-w-342",
                      onClick: $setup.onClickToggleContinueIssueDetails
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("continue")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id === 4 && !$setup.isShowIssueReview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_v_file_input, {
                              "append-inner-icon": "mdi-image-plus",
                              class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                              label: "Upload",
                              variant: "solo-filled",
                              modelValue: $setup.selectedFile,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedFile) = $event)),
                              onChange: $setup.onFileChange,
                              "onClick:clear": $setup.clearImageUrl,
                              multiple: "",
                              "append-icon": "mdi-upload",
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class", "onChange", "onClick:clear"]),
                            ($setup.imageUrl)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 0,
                                  class: "uploaded-img",
                                  width: 200,
                                  "aspect-ratio": "16/9",
                                  cover: "",
                                  src: $setup.imageUrl
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            ($setup.errorMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($setup.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_v_btn, {
                            block: "",
                            "aria-label": "Refresh",
                            class: "button button-orange",
                            onClick: $setup.addIssueImage,
                            disabled: !$setup.uploadedImages
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.attachmentDataList.length ? "ADD ANOTHER" : "add"), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"]),
                          _createVNode(_component_v_btn, {
                            "aria-label": "Refresh",
                            class: "button button-purple",
                            onClick: $setup.onClickPostIssue,
                            disabled: !$setup.isAttachmentDataValid,
                            loading: $setup.loading
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("COMPLETE & REVIEW ISSUE")
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled", "loading"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      ($setup.attachmentDataList.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attachmentDataList, (attachment, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "show_uploaded_details",
                                  key: index
                                }, [
                                  _createVNode(_component_v_img, {
                                    class: "uploaded-img",
                                    width: 156,
                                    height: 88,
                                    "aspect-ratio": "16/9",
                                    cover: "",
                                    src: attachment?.uploadedImages?.url
                                  }, null, 8, ["src"]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("h5", null, _toDisplayString(attachment?.uploadedImages?.name), 1),
                                    _createVNode(_component_v_btn, {
                                      onClick: ($event: any) => ($setup.removeImageFromAttachments(index)),
                                      variant: "text"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_35
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_v_combobox, {
                                      class: "selectprop_dropdown",
                                      modelValue: attachment.userCategoryName,
                                      "onUpdate:modelValue": ($event: any) => ((attachment.userCategoryName) = $event),
                                      items: $setup.userCategory,
                                      "item-title": "name",
                                      "item-value": "name",
                                      placeholder: "Enter or select category",
                                      multiple: "",
                                      "menu-props": {
                            contentClass: 'custom__text__selector',
                          }
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                  ]),
                                  _createVNode(_component_v_menu, {
                                    transition: "slide-y-reverse-transition",
                                    class: "slider-menu-active",
                                    activator: `#menu-activator-${index}`,
                                    active: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userCategory, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, {
                                                  class: "cursor-pointer",
                                                  onClick: ($event: any) => (attachment.userCategoryName = item?.name)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item?.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["activator"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              ($setup.isShowIssueReview && $setup.createdIssueId)
                ? (_openBlock(), _createBlock(_component_IssueReviewComponent, {
                    key: 0,
                    createdIssueId: $setup.createdIssueId,
                    issueDetails: $setup.issueDetails,
                    attachmentList: $setup.attachmentDataList,
                    onOnBackButton: $setup.onBackButton,
                    onGoToListIssuesTab: $setup.goToListIssuesTab,
                    onOnClickBackButton: $setup.onClickBackButtonFromReview
                  }, null, 8, ["createdIssueId", "issueDetails", "attachmentList", "onOnBackButton", "onGoToListIssuesTab", "onOnClickBackButton"]))
                : _createCommentVNode("", true)
            ])
          ]),
          ($setup.isShowRightIssueReviewCard($setup.currentSelectedTab?.id))
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_v_card, { class: "issue_type__overview_card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            (
                        $setup.issueDetails.issueType == 'emergency_out_of_hours' &&
                        $setup.selectedEOHEventDetails?.EOHProperties?.length
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedEOHEventDetails?.EOHProperties, (property) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: property.id
                                    }, _toDisplayString(property?.property?.address), 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString($setup.selectedPropertyDetails?.address), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("p", null, _toDisplayString($setup.selectedIssueTypeName), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_v_btn, {
                      class: "button button-purple-border",
                      size: "large",
                      block: "",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.onClickSaveIssueLater($setup.PropertyIssueStatus.DRAFT))),
                      loading: $setup.isShowLoaderOnSaveIssueForLater,
                      disabled: $setup.currentSelectedTab?.id === 3 && !$setup.isAttachmentDataValid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" save Issue for later ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_53, [
        ($setup.currentSelectedTab?.id === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              ($setup.currentSelectedTab?.id === 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    "aria-label": "Refresh",
                    class: "button button-purple",
                    disabled: !$setup.selectedIssueTypeName,
                    onClick: $setup.onClickToggleContinue
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("continue")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!$setup.isShowIssueReview)
          ? (_openBlock(), _createBlock(_component_v_stepper, {
              key: 1,
              class: "onboard-stepper",
              modelValue: $setup.currentSelectedTab.id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modelDetails, (step) => {
                      return (_openBlock(), _createBlock(_component_v_stepper_item, {
                        class: "onboard-stepper__item",
                        key: step.id,
                        title: step.tab,
                        value: step.id
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.isShowEmergencyOutHoursEventList)
      ? (_openBlock(), _createBlock(_component_EmergencyOutHoursEventList, {
          key: 0,
          onOnCloseEmergencyListModal: $setup.onCloseEmergencyListModal,
          onOnClickNextButton: $setup.onClickNextButton
        }, null, 8, ["onOnCloseEmergencyListModal", "onOnClickNextButton"]))
      : _createCommentVNode("", true),
    ($setup.isShowEmergencyOutHoursDetails)
      ? (_openBlock(), _createBlock(_component_EmergencyOutHoursDetails, {
          key: 1,
          onOnCloseDetailsModal: $setup.onCloseDetailsModal,
          onOnClickBackButton: $setup.openEmergencyOutHoursEventListModal,
          onOnClickNextButton: $setup.onClickEmergencyOutHoursDetailNextButton,
          selectedEOHEventDetails: $setup.selectedEOHEventDetails
        }, null, 8, ["onOnCloseDetailsModal", "onOnClickBackButton", "onOnClickNextButton", "selectedEOHEventDetails"]))
      : _createCommentVNode("", true)
  ], 64))
}